import getOr from 'lodash/fp/getOr';

import { changeLocale, languageDataFetched } from './actions';
import { getSupportedLocale as defaultGetSupportedLocale } from './selectors';
import { trace } from '../setup/trace';

// Webpack is weird sometimes, maybe it's Babel, who knows...
const normalizeDynamicImport = imported => getOr(imported, 'default', imported);

export const getLanguageData = locale =>
    import(/* webpackChunkName: "[request]" */ `../../translations/${locale}.json`)
        .then(normalizeDynamicImport)
        .catch(error => {
            console.error(error);
            return error;
        });

export const configureFetchLanguageData =
    (store, fetchLanguageData = getLanguageData, getSupportedLocale = defaultGetSupportedLocale) =>
    locale => {
        if (!locale) {
            console.warn('No "locale" supplied when fetching language data!');
            return Promise.reject();
        }

        store.dispatch(changeLocale(locale));
        const supportedLocale = getSupportedLocale(store.getState());
        return fetchLanguageData(supportedLocale)
            .then(languageData => {
                trace(`Language data fetched for "${supportedLocale}"`);
                store.dispatch(languageDataFetched(supportedLocale, languageData));
            })
            .catch(error => {
                console.error(`Language data for "${supportedLocale}" could not be fetched.`, error);
                return error;
            });
    };
